"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDev = exports.environmentString = exports.isQa = exports.isProduction = exports.isEU = exports.isBrowser = void 0;
exports.isBrowser = typeof window !== 'undefined';
var hasNodeEnv = function hasNodeEnv(env) {
  return DRIFT_ELECTRON_ENVIRONMENT === env;
};
var hasWindowEnv = function hasWindowEnv(env) {
  return exports.isBrowser && window.__ENV__ === env;
};
exports.isEU = exports.isBrowser && window.DRIFT_REGION === 'EU';
exports.isProduction = exports.isBrowser ? hasWindowEnv('PRODUCTION') : hasNodeEnv('production');
exports.isQa = exports.isBrowser ? hasWindowEnv('MASTER') : hasNodeEnv('qa');
exports.environmentString = exports.isProduction ? 'prod' : exports.isQa ? 'qa' : 'dev';
exports.isDev = exports.environmentString === 'dev';